export function useBucketAndPath(src: MaybeRefOrGetter) {
  const bucketAndPath = reactive({
    host: null as null | string,
    bucket: null as null | string,
    path: null as null | string,
  });

  watch(
    () => toValue(src),
    (src) => {
      try {
        const parsed = new URL(src);

        bucketAndPath.host = parsed.hostname;

        const [_, b, p] =
          parsed.pathname.match(/\/storage\/v1\/object\/public\/(.*?)\/(.*)/) ||
          [];

        bucketAndPath.bucket = b;
        bucketAndPath.path = p;
      } catch (x) {
        bucketAndPath.bucket = null;
        bucketAndPath.host = null;
        bucketAndPath.path = null;
      }
    },
    { immediate: true }
  );

  return bucketAndPath;
}
